import { useMemo } from 'react';

import { useDisclosure } from '@/hooks/useDisclosure';

import type { Option } from './types';

const useSelectMenu = ({
  options,
  onChange,
  value
}: {
  options: Option[];
  onChange: (userSetting: Option) => void;
  value: string | null;
}) => {
  const { isOpen: open, open: handleOpen, close: handleClose } = useDisclosure();

  const handleMenuItemClick = (index: number) => {
    onChange(options[index]);
    handleClose();
  };

  const selected = useMemo(() => {
    return options.find(option => option.value === value) || null;
  }, [options, value]);

  return {
    open,
    handleMenuItemClick,
    handleOpen,
    handleClose,
    selected
  };
};

export default useSelectMenu;
